import { Badge } from "@/components/ui/badge";

interface StatusOrdersCompletedProps {
    shipmentBlock?: number | null;
    orderNumber: string;
    cycleCode?: number | null;
}

export const StatusOrdersCompleted = ( { shipmentBlock, orderNumber, cycleCode }: StatusOrdersCompletedProps ) => {
    const shortCode = `${ cycleCode ?? "" }`.slice( -2 );

    if ( shortCode === '00' || orderNumber.includes( "SIM" ) ) {
        return (
            <div className="flex flex-col gap-0.5">
                <Badge variant="secondary" className="flex w-fit items-center gap-1">Avaliações e Simulados</Badge>
                {shipmentBlock != null && (
                    <span className="text-[12px] text-muted-foreground font-medium pl-1">
                        Remessa {shipmentBlock}
                    </span>
                )}
            </div>
        );
    }

    if ( shortCode === '02' ) {
        return (
            <Badge variant="outline" className="bg-purple-50 text-purple-700 border-purple-200 flex w-fit items-center gap-1">2º Semestre</Badge>
        );
    }

    if ( orderNumber.includes( "PED-S" ) ) {
        return (
            <Badge variant="outline" className="bg-purple-50 text-purple-700 border-purple-200 flex w-fit items-center gap-1">Semestral</Badge>
        );
    }

    if ( shortCode === '01' || orderNumber.includes( "PED-A" ) ) {
        return (
            <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200 flex w-fit items-center gap-1">Anual</Badge>
        );
    }


    return <Badge variant="outline">{cycleCode ?? "—"}</Badge>;
}
